
import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import { getBlogs } from "../api/auth/blogService";
import { getAllCategories } from "../api/auth/categoryService";

function Blogs() {
  const [categories, setCategories] = useState([]);
  const [blogs, setBlogs] = useState([]);
  const [posts, setPosts] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentIndex, setCurrentIndex] = useState(0);

  // Fetch categories
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const data = await getAllCategories();
        setCategories(data);
      } catch (error) {
        console.error("Error fetching categories:", error.message);
      }
    };
    fetchCategories();
  }, []);

  // Fetch all blogs
  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const data = await getBlogs();
        setBlogs(data);
        setPosts(data.slice(0, 5)); // also set sidebar recent posts
      } catch (error) {
        console.error("Error fetching blogs:", error.message);
      }
    };
    fetchBlogs();
  }, []);

  // Filter blogs by search
  const filteredBlogs = blogs.filter(
    (blog) =>
      blog.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
      blog.description.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Current blog (only 1 at a time)
  const currentBlog =
    filteredBlogs.length > 0 ? filteredBlogs[currentIndex % filteredBlogs.length] : null;

  // Navigation
  const handleNext = () => {
    if (filteredBlogs.length > 0) {
      setCurrentIndex((prev) => (prev + 1) % filteredBlogs.length);
    }
  };

  const handlePrev = () => {
    if (filteredBlogs.length > 0) {
      setCurrentIndex(
        (prev) => (prev - 1 + filteredBlogs.length) % filteredBlogs.length
      );
    }
  };


  return (
    <div>
      <Header />

      {/* Breadcrumbs */}
      <div className="breadcrumbs overlay">
        <div className="container">
          <div className="bread-inner">
            <div className="row">
              <div className="col-12">
                <h2>Blogs</h2>
                <ul className="bread-list">
                  <li>
                    <NavLink to="/">Resources</NavLink>
                  </li>
                  <li>
                    <i className="icofont-simple-right" />
                  </li>

                  <li className="active">Blogs</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>


      {/* Blog Section */}
      <section className="news-single section">
        <div className="container">
          <div className="row">
            {/* Blog Content */}
            <div className="col-lg-8 col-12">
              {currentBlog ? (
                <div className="col-12 mb-5">
                  <div className="news-head">
                    <img
                      src={
                        currentBlog.imageBytes
                          ? `data:image/jpeg;base64,${currentBlog.imageBytes}`
                          : "https://via.placeholder.com/800x400"
                      }
                      alt={currentBlog.title}
                      style={{ width: "100%", height: "400px", objectFit: "cover" }}
                    />
                  </div>

                  <h1 className="news-title">
                    {currentBlog.title}
                  </h1>

                  <div className="news-text">
                    <p>{currentBlog.description}</p>

                    {/* Gallery */}
                    {(currentBlog.image2 || currentBlog.image3) && (
                      <div className="image-gallery">
                        <div className="row">
                          {currentBlog.image2 && (
                            <div className="col-lg-6 col-md-6 col-12">
                              <img
                                src={`data:image/jpeg;base64,${currentBlog.image2}`}
                                alt="Gallery 1"
                                style={{ width: "100%", borderRadius: "6px" }}
                              />
                            </div>
                          )}
                          {currentBlog.image3 && (
                            <div className="col-lg-6 col-md-6 col-12">
                              <img
                                src={`data:image/jpeg;base64,${currentBlog.image3}`}
                                alt="Gallery 2"
                                style={{ width: "100%", borderRadius: "6px" }}
                              />
                            </div>
                          )}
                        </div>
                      </div>
                    )}

                    {/* Quote */}
                    {currentBlog.quote && (
                      <blockquote className="overlay">
                        <p>{currentBlog.quote}</p>
                      </blockquote>
                    )}

                    {/* Meta Info */}
                    <div className="meta d-flex justify-content-between mt-3">
                      <span className="author">By {currentBlog.name}</span>
                      <span className="date">
                        <i className="fa fa-clock-o"></i>{" "}
                        {currentBlog.date
                          ? new Date(currentBlog.date).toLocaleDateString("en-GB", {
                            day: "2-digit",
                            month: "short",
                            year: "numeric",
                          })
                          : "N/A"}
                      </span>
                    </div>
                  </div>
                </div>
              ) : (
                <p>No blog entries available.</p>
              )}

              {/* Navigation Buttons */}
              {filteredBlogs.length > 1 && (
                <div className="d-flex justify-content-end gap-2 mt-3">
                  <button className="btn btn-secondary" onClick={handlePrev}>
                    Previous
                  </button>
                  <button className="btn btn-primary" onClick={handleNext}>
                    Next
                  </button>
                </div>
              )}

            </div>

            {/* Sidebar */}
            <div className="col-lg-4 col-12">
              <div className="main-sidebar">
                {/* Search */}
                <div className="single-widget search">
                  <div className="form">
                    <input
                      type="text"
                      placeholder="Search Here..."
                      value={searchTerm}
                      onChange={(e) => {
                        setSearchTerm(e.target.value);
                        setCurrentIndex(0); // reset to first result
                      }}
                    />
                    <button className="button">
                      <i className="fa fa-search"></i>
                    </button>
                  </div>
                </div>

                {/* Categories */}
                <div className="single-widget category">
                  <h3 className="title">Blog Categories</h3>
                  <ul className="categor-list">
                    {categories.map((cat) => (
                      <li key={cat.id}>
                        {cat.category}
                      </li>
                    ))}
                  </ul>
                </div>

                {/* Recent Posts */}
                <div className="single-widget recent-post">
                  <h3 className="title">Recent Posts</h3>
                  {posts.length > 0 ? (
                    posts.slice(0, 2).map((post) => (
                      <div className="single-post" key={post.id}>
                        <div className="image">
                          <img
                            src={
                              post.imageBytes
                                ? `data:image/jpeg;base64,${post.imageBytes}`
                                : "img/blog-sidebar1.jpg"
                            }
                            alt={post.title}
                          />
                        </div>
                        <div className="content">
                          <h5>
                            <a href="/blogs">{post.title}</a>
                          </h5>
                          <ul className="comment">
                            <li>
                              <i className="fa fa-calendar" aria-hidden="true"></i>{" "}
                              {new Date(post.date).toDateString()}
                            </li>
                          </ul>
                        </div>
                      </div>
                    ))
                  ) : (
                    <p>No recent posts available</p>
                  )}
                </div>

              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default Blogs;
